export const API = {
  IN: '/inventory/movements/in',
  OUT: '/inventory/movements/out',
  MOVE: '/inventory/movements/move',
  REPLACE: '/inventory/movements/replace',
  ADJUST: '/inventory/movements/adjust',
  RESERVE: '/inventory/movements/reserve',
  RELEASE: '/inventory/movements/release',
  WRITE_OFF: '/inventory/movements/write-off',
  BALANCE: '/inventory/balance',
  STORE_PRODUCTS: (storeId: string) => `/inventory/store/${storeId}/products`,
  HISTORY: (productId: string) => `/inventory/product/${productId}/history`,
  FLOW: (storeId: string) => `/inventory/store/${storeId}/flow`,
  AGING: '/inventory/aging',
  MOVEMENTS_BY_STORE_STATE: (storeId: string, status: string) =>
    `/inventory/movements/store/${storeId}/${status}`,
} as const;
